export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-axis/src/identity.js
// module id = ../../../../d3-axis/src/identity.js
// module chunks = 3